// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"31449f34","132":"3d9afa31","221":"18bcf8a3","514":"47599629","537":"c2776a7a","579":"451ea2c0","664":"a7a1f615","750":"3ad0f917","784":"7f248522","827":"392f3e9b","845":"d45a4e11","895":"c2787790","963":"af4b2a7f","970":"8d2a20ce"}[chunkId] + ".chunk.js";
};